import { format, subDays } from "date-fns";

export function numDifferentiation(val, precise = 2) {
  if (val >= 10000000) val = (val / 10000000 + 0.004).toFixed(precise) + " Cr";
  else if (val >= 100000)
    val = (val / 100000 + 0.004).toFixed(precise) + " Lac";
  else if (val >= 1000) val = (val / 1000 + 0.004).toFixed(precise) + " K";
  return val;
}

export const formatToCommaString = (number, region = "en-IN") => {
  if (number == null) return "0";
  return number.toLocaleString(region);
};

export const formatToCommaStringDecPoint = (number, region = "en-IN") => {
  if (number == null) return "0";
  return number.toLocaleString(region, { maximumFractionDigits: 2 });
};

export const percentageCalc = (neu, deno) => {
  if (deno === 0) {
    //return Math.floor(Math.random() * 100);
    return 0;
  }

  return (neu / deno) * 100.0;
};

export const toCompactNumber = (n) => {
  if (n < 1e3) return n;
  if (n < 1e6) return +(n / 1e3).toFixed(1) + "K";
  if (n < 1e9) return +(n / 1e6).toFixed(1) + "M";
  if (n < 1e12) return +(n / 1e9).toFixed(1) + "B";
  return +(n / 1e12).toFixed(1) + "T";
};

export const formattedDate = (date) => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = date.getMonth();
  const formattedString =
    date.getDate() + " " + monthNames[month] + ", " + date.getFullYear();

  return formattedString;
};

export const formattedYesterday = () => {
  const today = new Date();
  var yesterday = new Date(today);

  yesterday.setDate(today.getDate() - 1);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var month = today.getMonth();
  yesterday =
    yesterday.getDate() +
    " " +
    monthNames[month] +
    ", " +
    yesterday.getFullYear();

  return yesterday;
};

export const formatDate = (dateString) => {
  const dateYesterday = new Date(dateString);
  const date = subDays(dateYesterday, 1);
  const formattedDate = format(date, "EEEE, MMMM d");

  return formattedDate;
};

export const getGrowthTrendColor = (growth) => {
  if (growth === null) return "#000000";
  if (growth > 0) return "#2E8B57";
  if (growth < 0) return "#FA003F";
  return "#000000";
};
